<div class="header">
  <span class="mat-subtitle-2">{{
    (this.inputs.initialValue == null
      ? 'LOCATION_SIDEBAR_CREATE'
      : 'LOCATION_SIDEBAR_EDIT'
    ) | i18nextCap
  }}</span>
  <button
    mat-icon-button
    type="button"
    aria-label="Close"
    (click)="inputs.onCancel()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<form [formGroup]="formGroup" (ngSubmit)="save()">
  <mat-form-field>
    <mat-label>{{ 'name' | i18nextCap }}</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'forms:externalId' | i18nextCap }}</mat-label>
    <input matInput formControlName="externalId" />
  </mat-form-field>
  <div class="primary-location-form-container">
    <mat-slide-toggle formControlName="primary">
      {{ 'forms:primaryLocation' | i18nextCap }}
    </mat-slide-toggle>
  </div>
  @if (initialValue?.createdAt != null) {
    <mat-form-field>
      <mat-label>{{ 'createdAt' | i18nextCap }}</mat-label>
      <input
        disabled
        matInput
        value="{{
          initialValue.createdAt
            | momentTimezoneToAngularTimezone: 'DD/MM/YYYY HH:mm'
        }}"
      />
    </mat-form-field>
  }
  @if (company != null) {
    <div class="company-field-row">
      <mat-form-field>
        <mat-label>{{ 'company' | i18nextCap }}</mat-label>
        <input
          disabled
          matInput
          value="{{ company?.name ?? ('companyNotAssigned' | i18nextCap) }}"
        />
      </mat-form-field>
      <button
        mat-icon-button
        color="primary"
        [disabled]="company?.id == null"
        [routerLink]="['/', 'companies', company?.id, 'edit']"
      >
        <mat-icon>account_balance</mat-icon>
      </button>
    </div>
  }
  <mat-form-field class="d-block address-input">
    <mat-label>{{ 'forms:address' | i18nextCap }} </mat-label>
    <input matInput type="text" formControlName="streetName" />
  </mat-form-field>
  <mat-form-field class="d-block">
    <mat-label>{{ 'forms:supplierCity' | i18nextCap }} </mat-label>
    <input matInput type="text" formControlName="city" />
  </mat-form-field>
  <mat-form-field class="d-block">
    <mat-label>{{ 'forms:zipCode' | i18nextCap }} </mat-label>
    <input matInput type="text" formControlName="postalCode" />
  </mat-form-field>
  <mat-form-field class="d-block">
    <mat-label>{{ 'forms:country' | i18nextCap }}</mat-label>
    <fo-autocompleting-select
      formControlName="countryId"
      [choices]="countries$"
      valueField="id"
    ></fo-autocompleting-select>
  </mat-form-field>
  <mat-form-field class="d-block">
    <mat-label>{{ 'forms:distance' | i18nextCap }}</mat-label>
    <input matInput type="number" formControlName="distance" min="0" step="1" />
  </mat-form-field>
  <mat-form-field class="d-block">
    <mat-label>{{ 'forms:travelTime' | i18nextCap }}</mat-label>
    <mat-select formControlName="travelTime">
      @for (slot of travelTimeOptions; track slot.dayMinute) {
        <mat-option [value]="slot.dayMinute">
          {{ slot.displayText }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div class="footer">
    @if (inputs.initialValue != null) {
      <button mat-button color="warn" type="button" (click)="delete()">
        {{ 'delete' | i18nextCap }}
      </button>
    }
    <button mat-flat-button color="primary" type="submit">
      {{ 'save' | i18nextCap }}
    </button>
  </div>
</form>
